import axios from 'axios';

const instance = axios.create({
    baseURL:"https://api.reso.chat"
})

export default instance;